export { getCurrentLocale } from '../repositories/localeRepository'
